import * as CookieConsent from 'vanilla-cookieconsent';
import persistAndEmitConsentFromCookie from '../persistAndEmitConsentFromCookie';
import type { ConsentParams } from '../../constants';

type Args = {
  storageKey: string;
  setConsentState: (consent: ConsentParams) => void;
};

const createConsentHandlers = ({ storageKey, setConsentState }: Args) => {
  const onConsent = ({ cookie }: { cookie: CookieConsent.CookieValue }) =>
    persistAndEmitConsentFromCookie({
      cookie,
      storageKey,
      setConsentState,
    });

  const onFirstConsent = ({ cookie }: { cookie: CookieConsent.CookieValue }) =>
    persistAndEmitConsentFromCookie({
      cookie,
      storageKey,
      setConsentState,
    });

  const onChange = ({ cookie }: { cookie: CookieConsent.CookieValue }) =>
    persistAndEmitConsentFromCookie({
      cookie,
      storageKey,
      setConsentState,
    });

  return { onConsent, onFirstConsent, onChange };
};

export default createConsentHandlers;
